module.exports = __webpack_public_path__ + "img/Expo_Topic3.b972b6b3.png";